(function (global) {
    "use strict";

    var __ = function (s) {
        var args = arguments;
        if (typeof window.__ === "function") return window.__.apply(null, args);
        return String(s).replace(/\{(\d)\}/g, function (m, n) { return args[+n + 1] != null ? args[+n + 1] : m; });
    };

    var BABYLON_RUNTIME = "https://cdn.jsdelivr.net/npm/babylonjs@9.26.2/babylon.js";
    var CDN = "https://cdn.sharkguitars.com/";
    var babylonPromise = null;
    var active = null;
    var overlay, swatch, title, note;
    var returnFocus = null;
    var previousOverflow = "";
    var bound = false;

    function loadBabylon() {
        if (global.BABYLON) return Promise.resolve(global.BABYLON);
        if (babylonPromise) return babylonPromise;
        babylonPromise = new Promise(function (resolve, reject) {
            var script = document.createElement("script");
            script.src = BABYLON_RUNTIME;
            script.async = true;
            script.dataset.woodInspectorRuntime = "babylon";
            script.onload = function () { global.BABYLON ? resolve(global.BABYLON) : reject(new Error("Babylon loaded without a runtime")); };
            script.onerror = function () { reject(new Error("Babylon material runtime could not load")); };
            document.head.appendChild(script);
        });
        return babylonPromise;
    }

    function dispose() {
        if (!active) return;
        active.dispose();
        active = null;
    }

    function roundedHexBoundary(radius, rounding, cornerSegments) {
        var corners = [], points = [], i, step;
        for (i = 0; i < 6; i += 1) {
            var angle = -i * Math.PI / 3;
            corners.push({ x: Math.cos(angle) * radius, y: Math.sin(angle) * radius });
        }
        for (i = 0; i < corners.length; i += 1) {
            var vertex = corners[i], previous = corners[(i + 5) % 6], next = corners[(i + 1) % 6];
            var start = { x: vertex.x + (previous.x - vertex.x) * rounding, y: vertex.y + (previous.y - vertex.y) * rounding };
            var end = { x: vertex.x + (next.x - vertex.x) * rounding, y: vertex.y + (next.y - vertex.y) * rounding };
            for (step = 0; step <= cornerSegments; step += 1) {
                var t = step / cornerSegments, inverse = 1 - t;
                points.push({
                    x: inverse * inverse * start.x + 2 * inverse * t * vertex.x + t * t * end.x,
                    y: inverse * inverse * start.y + 2 * inverse * t * vertex.y + t * t * end.y
                });
            }
        }
        return points;
    }

    function createRoundedHexSurface(B, scene, radius) {
        var boundary = roundedHexBoundary(radius, 0.21, 5), facePositions = [0, 0, 0], faceUvs = [0.5, 0.5], faceIndices = [];
        boundary.forEach(function (point) {
            facePositions.push(point.x, point.y, 0);
            faceUvs.push(0.5 + point.x / (radius * 2), 0.5 - point.y / (radius * 2));
        });
        boundary.forEach(function (_, index) {
            faceIndices.push(0, index + 1, (index + 1) % boundary.length + 1);
        });
        var faceNormals = [];
        B.VertexData.ComputeNormals(facePositions, faceIndices, faceNormals);
        var surface = new B.Mesh("wood-surface", scene), faceData = new B.VertexData();
        faceData.positions = facePositions;
        faceData.indices = faceIndices;
        faceData.normals = faceNormals;
        faceData.uvs = faceUvs;
        faceData.applyToMesh(surface);
        return surface;
    }

    function open(canvas, options) {
        dispose();
        return loadBabylon().then(function (B) {
            if (!canvas || !canvas.isConnected) return null;
            var engine = new B.Engine(canvas, true, { alpha: true, antialias: true, preserveDrawingBuffer: false, stencil: true }, true);
            var scene = new B.Scene(engine);
            scene.clearColor = new B.Color4(0, 0, 0, 0);
            scene.imageProcessingConfiguration.exposure = 1.56;
            scene.imageProcessingConfiguration.contrast = 1.22;
            var camera = new B.FreeCamera("wood-inspector-camera", new B.Vector3(0, 0, -4.65), scene);
            camera.setTarget(B.Vector3.Zero());
            camera.minZ = 0.1;

            var surface = createRoundedHexSurface(B, scene, 1.67);

            var material = new B.PBRMaterial("wood-material", scene);
            material.albedoTexture = new B.Texture(options.albedo, scene, false, false, B.Texture.TRILINEAR_SAMPLINGMODE);
            material.albedoTexture.wrapU = material.albedoTexture.wrapV = B.Texture.CLAMP_ADDRESSMODE;
            if (options.normal) {
                material.bumpTexture = new B.Texture(options.normal, scene, false, false, B.Texture.TRILINEAR_SAMPLINGMODE);
                material.bumpTexture.wrapU = material.bumpTexture.wrapV = B.Texture.CLAMP_ADDRESSMODE;
                material.bumpTexture.level = 5.75;
                material.useParallax = true;
                material.useParallaxOcclusion = true;
                material.parallaxScaleBias = 0.10;
            }
            material.roughness = 0.48;
            material.metallic = 0.02;
            material.backFaceCulling = false;
            material.clearCoat.isEnabled = true;
            material.clearCoat.intensity = 0.16;
            material.clearCoat.roughness = 0.54;
            surface.material = material;

            var hemi = new B.HemisphericLight("wood-fill", new B.Vector3(0, 1, -1), scene);
            hemi.intensity = 1.5;
            hemi.diffuse = new B.Color3(1, 0.96, 0.9);
            hemi.groundColor = new B.Color3(0.2, 0.15, 0.12);
            var rake = new B.PointLight("wood-rake", new B.Vector3(-2.4, 2.2, -3.1), scene);
            rake.diffuse = new B.Color3(1, 0.88, 0.68);
            rake.specular = new B.Color3(1, 0.95, 0.86);
            rake.intensity = 7.6;
            rake.radius = 1.55;
            var rim = new B.PointLight("wood-rim", new B.Vector3(2.7, -1.35, -2.55), scene);
            rim.diffuse = new B.Color3(1, 0.93, 0.82);
            rim.specular = new B.Color3(1, 0.97, 0.91);
            rim.intensity = 3.35;
            rim.radius = 2.35;
            var front = new B.PointLight("wood-front-fill", new B.Vector3(0.15, 0.25, -3.45), scene);
            front.diffuse = new B.Color3(1, 0.96, 0.88);
            front.specular = new B.Color3(1, 0.98, 0.94);
            front.intensity = 2.9;
            front.radius = 3.2;
            var overhead = new B.PointLight("wood-right-overhead", new B.Vector3(2.8, 3, -2.85), scene);
            overhead.diffuse = new B.Color3(1, 0.94, 0.82);
            overhead.specular = new B.Color3(1, 0.98, 0.9);
            overhead.intensity = 4.4;
            overhead.radius = 1.45;

            var restX = -0.1, restY = 0.12;
            var targetX = restX, targetY = restY, currentX = restX, currentY = restY;
            function move(event) {
                var rect = canvas.getBoundingClientRect();
                var nx = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
                var ny = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
                targetX = restX + Math.max(-1, Math.min(1, ny)) * -0.36;
                targetY = restY + Math.max(-1, Math.min(1, nx)) * 0.48;
                rake.position.x = nx * 3.8;
                rake.position.y = -ny * 2.6;
            }
            function resetTilt() { targetX = restX; targetY = restY; rake.position.x = -2.4; rake.position.y = 2.2; }
            canvas.addEventListener("pointermove", move);
            canvas.addEventListener("pointerleave", resetTilt);
            canvas.addEventListener("pointercancel", resetTilt);

            engine.runRenderLoop(function () {
                currentX += (targetX - currentX) * 0.085;
                currentY += (targetY - currentY) * 0.085;
                surface.rotation.x = currentX;
                surface.rotation.y = currentY;
                scene.render();
            });
            var resizeObserver = new ResizeObserver(function () { engine.resize(); });
            resizeObserver.observe(canvas);
            active = {
                dispose: function () {
                    resizeObserver.disconnect();
                    canvas.removeEventListener("pointermove", move);
                    canvas.removeEventListener("pointerleave", resetTilt);
                    canvas.removeEventListener("pointercancel", resetTilt);
                    scene.dispose();
                    engine.dispose();
                }
            };
            engine.resize();
            return active;
        });
    }

    function woodRecord(id) {
        var records = (global.SHARK_ITEM_META && global.SHARK_ITEM_META.wood_material) || {};
        if (records[id]) return records[id];
        var wanted = String(id || "").toLowerCase().replace(/[^a-z0-9]+/g, "_");
        var keys = Object.keys(records);
        for (var i = 0; i < keys.length; i += 1) {
            var record = records[keys[i]];
            if (keys[i] === wanted || String(record.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "_") === wanted) return record;
        }
        return null;
    }

    function openOverlay(trigger) {
        var record = woodRecord(trigger && trigger.dataset.woodInspectId);
        if (!record || !overlay || !swatch) return;
        var assets = record.assets || {};
        var albedo = assets.inspection || assets.preview;
        if (!albedo) return;
        returnFocus = trigger;
        previousOverflow = document.body.style.overflow;
        if (title) title.textContent = trigger.dataset.woodName || record.name || __("Wood material");
        var albedoUrl = CDN + albedo;
        var normalUrl = assets.normal ? CDN + assets.normal : (assets.bw ? CDN + assets.bw : null);
        swatch.innerHTML = '<img class="wood-inspect-fallback" src="' + albedoUrl.replace(/"/g, "&quot;") + '" alt=""><canvas class="wood-inspect-canvas" aria-label="' + __("Interactive material surface") + '"></canvas>';
        overlay.inert = false;
        overlay.classList.add("open");
        overlay.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        overlay.querySelector(".wood-inspect-close").focus();
        var canvas = swatch.querySelector("canvas");
        var fallback = swatch.querySelector(".wood-inspect-fallback");
        open(canvas, { albedo: albedoUrl, normal: normalUrl }).then(function () {
            if (fallback) fallback.hidden = true;
        }).catch(function () {
            if (canvas) canvas.hidden = true;
        });
    }

    function closeOverlay() {
        if (!overlay || !overlay.classList.contains("open")) return;
        dispose();
        overlay.classList.remove("open");
        overlay.setAttribute("aria-hidden", "true");
        overlay.inert = true;
        document.body.style.overflow = previousOverflow;
        swatch.innerHTML = "";
        var target = returnFocus && returnFocus.isConnected && returnFocus.getClientRects().length ? returnFocus : null;
        if (target && target.focus) target.focus();
        returnFocus = null;
    }

    function bind() {
        if (bound) return;
        overlay = document.getElementById("wood-inspect-overlay");
        if (!overlay) return;
        bound = true;
        swatch = document.getElementById("wood-inspect-swatch");
        title = document.getElementById("wood-inspect-title");
        note = document.getElementById("wood-inspect-note");
        if (overlay.parentElement !== document.body) {
            overlay.classList.add("item-v10");
            document.body.appendChild(overlay);
        }
        document.addEventListener("click", function (event) {
            var trigger = event.target.closest("[data-wood-inspect-id]");
            if (trigger) {
                openOverlay(trigger);
                return;
            }
            if (event.target.closest("[data-wood-inspect-close]")) closeOverlay();
        });
        document.addEventListener("keydown", function (event) {
            if (!overlay.classList.contains("open")) return;
            if (event.key === "Escape") {
                closeOverlay();
                return;
            }
            if (event.key !== "Tab") return;
            var controls = Array.prototype.slice.call(overlay.querySelectorAll('button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])'));
            if (!controls.length) return;
            var first = controls[0], last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind);
    else bind();

    global.SHARK_WOOD_INSPECTOR = { open: open, dispose: dispose };
})(window);
